import React, { useState, useEffect, useRef } from "react";
import "./Search.scss";
import Icon from "../Icon";
import useOnclickOutside from "react-cool-onclickoutside";

function Search({ placeholder, value, onClick, isOpen, filterClients, response }) {
  const [initiated, setInitiated] = useState(false);
  const [hits, _setHits] = useState(false);
  const [key_index, _set_key_index] = useState(0);
  const [scrollHeight, _setScrollHeight] = useState(0);
  const [local_value, set_local_value] = useState(value ? value : "");
  const textInput = useRef();
  const key_index_ref = useRef(key_index);
  const scrollHeight_ref = useRef(scrollHeight);
  const hits_ref = useRef(hits);

  
  const setHits = (data) => {
    
    hits_ref.current = data;
    _setHits(data);
  };

  const set_key_index = (data) => {
    key_index_ref.current = data;
    _set_key_index(data);
  };

  const setScrollHeight = (data) => {
    scrollHeight_ref.current = data;
    _setScrollHeight(data);
  };

  const ref = useOnclickOutside(() => {
    setHits(false);
    set_key_index(0);
    setScrollHeight(0);
  });

  useEffect(() => {
    if (hits) {
      if (textInput.current !== null && !initiated) {
        setInitiated(true);
        window.addEventListener("keydown", (e) => keydownListener(e), true);
      }
    }

    return () => {
      window.removeEventListener("keydown", (e) => keydownListener(e), true);
    };
  }, [hits]);

  // useEffect(() => {
  //   
  //   if (hits) {
  //     isOpen(true);
  //   } else {
  //     isOpen(false);
  //   }
  // }, [hits]);

  useEffect(() => {
    set_local_value(value);
  }, [value]);

  const keydownListener = (e) => {
    if (e.keyCode === 40 && key_index_ref.current < hits_ref.current.length - 1) {
      set_key_index(key_index_ref.current + 1);
      if (key_index_ref.current > 0 && textInput.current.scroll !== null) {
        let newScrollHeight = scrollHeight_ref.current;
        textInput.current.scroll({
          top: scrollHeight_ref.current,
          left: 0,
          behavior: "smooth",
        });
        newScrollHeight += 35;
        setScrollHeight(() => newScrollHeight);
      }
    }
    if (e.keyCode === 38 && key_index_ref.current > 0) {
      set_key_index(key_index_ref.current - 1);
      if (scrollHeight_ref.current >= 0 && textInput.current.scroll !== null) {
        let newScrollHeight = scrollHeight_ref.current;
        textInput.current.scroll({
          top: scrollHeight_ref.current,
          left: 0,
          behavior: "smooth",
        });
        newScrollHeight -= 35;
        setScrollHeight(() => newScrollHeight);
      }
    }
    if (e.keyCode === 13) {
      handleHitClick(hits_ref.current[key_index_ref.current]);
    }
    if (e.keyCode === 27) {
      setHits(false);
      set_key_index(0);
      setScrollHeight(0);
    }
  };

  const searchClient = (event) => {
    set_local_value(event.target.value);

    let name = response.filter((item) => {
      let searchResult = item.name.toLowerCase();
      return searchResult.indexOf(event.target.value.toLowerCase()) != -1;
    });
    setHits(name);
    filterClients(name);
  };

  function handleHitClick(hit) {
    
    if (hit) {
      onClick(hit);
      setHits(false);
      set_key_index(0);
      setScrollHeight(0);
    }
  }

  return (
    <div ref={ref} className="c-search-wrapper">
      <div className="c-search">
        <input placeholder={placeholder ? placeholder : ""} value={local_value} type="text" onClick={(e) => searchClient(e)} onChange={(e) => searchClient(e)} autofill="off" autocomplete="off" />
        <Icon icon="search" />
      </div>
      {hits && (
        <div ref={textInput} className="c-search-results">
          {hits.map((hit, idx) => (
            <div key={idx} className={key_index === idx ? "c-hit --selected" : "c-hit"} onClick={() => handleHitClick(hit)}>
              <p>{hit.name}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Search
